/**
 * Configuración global de mutations
 */
export const ON_ROUTE = "ON_ROUTE";
export const ON_IS_LOADING = "ON_IS_LOADING";
export const ON_LOADER_CONTENT = "ON_LOADER_CONTENT";
export const ON_LANDING = "ON_LANDING";
export const ON_GRACIAS = "ON_GRACIAS";
export const ON_PASO1 = "ON_PASO1";
export const ON_NORMALIZE_ALTERNATIVO = "ON_NORMALIZE_ALTERNATIVO";
export const ON_NORMALIZE_PARTICULAR = "ON_NORMALIZE_PARTICULAR";
export const ON_PASO2 = "ON_PASO2";
export const ON_PASO3 = "ON_PASO3";
export const ON_PASO8 = "ON_PASO8";
export const ON_NOTIFICATION_TOAST = "ON_NOTIFICATION_TOAST";
export const ON_FORZAR_DNE = "ON_FORZAR_DNE";
export const ON_SUCURSALES = "ON_SUCURSALES";
export const ON_ERROR = "ON_ERROR";
export const ON_OFERTA = "ON_OFERTA";
export const ON_INICIAR_SOLICITUD = "ON_INICIAR_SOLICITUD";
export const ADOBE_INTERNAL_LINK = "ADOBE_INTERNAL_LINK";
export const ADOBE_APPSTARTED = "ADOBE_APPSTARTED";
export const ADOBE_APP_ON_CLICK_START = "ADOBE_APP_ON_CLICK_START";
export const ADOBE_ERROR = "ADOBE_ERROR";
export const ON_CONTADOR_MERLIN = "ON_CONTADOR_MERLIN";
export const ON_RESET_CONTADOR_MERLIN = "ON_RESET_CONTADOR_MERLIN";
export const ON_IS_BTD3 = "ON_IS_BTD3";
export const ON_LOGIN = "ON_LOGIN";
export const ON_BIOMETRIA = "ON_BIOMETRIA";
export const ON_BIOMETRIA_POSITIVO = "ON_BIOMETRIA_POSITIVO";
export const ON_PRELOAD_SDK = "ON_PRELOAD_SDK";
export const ON_IS_VISIBLE_SDK = "ON_IS_VISIBLE_SDK";
export const ON_SAVE_IFRAME = "ON_SAVE_IFRAME";
export const ON_DIA_DEBITO = "ON_DIA_DEBITO";
export const ON_ENTREGA = "ON_ENTREGA";
export const ON_CONTRATACION = "ON_CONTRATACION";
export const ON_FIRMA_CONTRATOS = "ON_FIRMA_CONTRATOS";
export const ON_THANKS_VERIDAS = "ON_THANKS_VERIDAS";
export const ON_RESULT_VERIDAS = "ON_RESULT_VERIDAS";
export const ON_RESPONSE_VERIDAS = "ON_RESPONSE_VERIDAS";
export const ON_DIGITAL = "ON_DIGITAL";
export const ON_ERROR_VERIDAS = "ON_ERROR_VERIDAS";
export const ON_GET_RESULT_BIOMETRIA = "ON_GET_RESULT_BIOMETRIA";
export const ON_GUARDO_PASO = "ON_GUARDO_PASO";
export const ON_KEY = "ON_KEY";
export const ON_CONTADOR_BIO = "ON_CONTADOR_BIO";
export const ON_PRESENCIAL = "ON_PRESENCIAL";
export const ON_CONSULTA_CONTRATO = "ON_CONSULTA_CONTRATO";
export const ON_CONSULTA = "ON_CONSULTA";
export const ON_FUNNEL_ERROR = "ON_FUNNEL_ERROR";
export const ON_OTP_ONE = "ON_OTP_ONE";
export const ON_OTP_ERROR = "ON_OTP_ERROR";
export const ON_VALIDAR_CELULAR = "ON_VALIDAR_CELULAR";
export const ON_CREAR_USUARIO = "ON_CREAR_USUARIO";
export const ON_NORMALIZARCELULAR = "ON_NORMALIZARCELULAR";
export const ON_ACTUALIZAR_ESTADO_TYC = "ON_ACTUALIZAR_ESTADO_TYC";
export const ON_TCODE = "ON_TCODE";
export const ON_ADOBE_TARGET_EXPERIENCE = "ON_ADOBE_TARGET_EXPERIENCE";
export const ON_USER_ID_TOKENIZADO = "ON_USER_ID_TOKENIZADO";
export const ON_DEVICEID = "ON_DEVICEID";
export const ON_DEVICEIDTIMESTAMP = "ON_DEVICEIDTIMESTAMP";
export const ON_CLEAR_CONSULTA_PH = "ON_CLEAR_CONSULTA_PH";
export const ON_LINEAS_PH = "ON_LINEAS_PH";
export const ON_CONSULTA_PH = "ON_CONSULTA_PH";
export const ON_CONFIRMAR_SIMULACION_PH = "ON_CONFIRMAR_SIMULACION_PH";
export const ON_TOGGLE_TERMS_AND_CONDITIONS = "ON_TOGGLE_TERMS_AND_CONDITIONS";
export const SET_CONSULTA_PAYLOAD = "SET_CONSULTA_PAYLOAD";
export const SET_RENAPER_CALLED = "SET_RENAPER_CALLED";
export const ON_FECHA_SISTEMA = "ON_FECHA_SISTEMA";
export const SET_MAX_AMOUNT = "SET_MAX_AMOUNT";
export const ON_COTIZACION = "ON_COTIZACION";
export const SET_DVS_IFRAME_DATA = "SET_DVS_IFRAME_DATA";
export const ON_DATA_AUTH_ASO = "ON_DATA_AUTH_ASO";
export const ADOBE_HIPOTECARIO_PAGE_VISIT = "ADOBE_HIPOTECARIO_PAGE_VISIT";
export const ADOBE_CALCULADORA_VALOR_STEP_2 = "ADOBE_CALCULADORA_VALOR_STEP_2";
export const ADOBE_CALCULADORA_VALOR_STEP_3 = "ADOBE_CALCULADORA_VALOR_STEP_3";
export const ADOBE_CALCULADORA_VALOR_STEP_4 = "ADOBE_CALCULADORA_VALOR_STEP_4";
export const ADOBE_CALCULADORA_VALOR_STEP_5 = "ADOBE_CALCULADORA_VALOR_STEP_5";
export const ON_PRESCRIPTOR = "ON_PRESCRIPTOR";
export const ON_RESET_FORM = "ON_RESET_FORM";
export const SET_LANDING_QR_URL = "SET_LANDING_QR_URL";
export const UPDATE_CONSULTA = "UPDATE_CONSULTA";
export const UPDATE_OFERTA = "UPDATE_OFERTA";
